var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalInfoIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.094c0-3.147 2.629-5.697 8-5.697s8 2.55 8 5.697c0 .5-.365.906-.816.906H2.816c-.45 0-.816-.406-.816-.906ZM13 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfoIconActive);
export default __webpack_public_path__ + "static/media/personal-info-icon-active.9bdde2d8baf6a93768b78ccaacd9cea0.svg";
export { ForwardRef as ReactComponent };